import Element from '../../../Prototype/UI/Element';
import Game from '../../../Game';
import GameObject, { GameObjectEvent } from '../../../GameObject/GameObject';
import { applyDefaultButtonAnimation } from '../../../System/UI/UIHelper';
import { UIActions } from '../../../State/UI/UIActions';
import ButtonComponent from '../../../Component/UI/ButtonComponent';
import Renderable from '../../../Component/Renderable';
import { isLevelCompletedSuccessfully } from '../../../State/Level/LevelStateHelper';
import { GameScene } from '../../../State/Game/GameScene';
import { PopupID } from '../../../State/UI/PopupID';

export default class SettingsButton extends Element {
    public static _name: string;
    public static BTN_NAME: string = 'button';

    public create(params: { highestLevel: number; [key: string]: any }): void {
        SettingsButton._name = params.name;

        super.create({
            name: params.name,
            layout: {
                anchors: [0.5, 0.5, 0.5, 0.5],
                pivot: [0.5, 0.5],
                offsets: [0, 0, 0, 0],
                scale: [1, 1],
                ...params.layout,
            },
            children: [
                {
                    name: 'background',
                    layout: {
                        anchors: [0.5, 0.5, 0.5, 0.5],
                        pivot: [0.5, 0.5],
                        offsets: [0, 0, 0, 0],
                        scale: [1, 1],
                    },
                    components: [
                        {
                            type: 'image',
                            data: {
                                cacheKey: 'blank',
                            },
                        },
                    ],
                    children: [
                        {
                            name: 'button',
                            layout: {
                                anchors: [0.5, 0.5, 0.5, 0.5],
                                pivot: [0.5, 0.5],
                                offsets: [1, 1, 1, 1],
                            },
                            components: [
                                {
                                    type: 'input',
                                    data: {
                                        enabled: true,
                                        buttonMode: true,
                                        toggleable: true,
                                        tintOnDisable: true,
                                    },
                                },
                                {
                                    type: 'image',
                                    data: {
                                        cacheKey: 'button_round_settings',
                                    },
                                },
                            ],
                        },
                    ],
                },
            ],
            ...params,
        });
        const button: GameObject = this.button;
        button.addComponent(ButtonComponent, {
            toggleable: true,
        });
        button.on(GameObjectEvent.SELECTED, this.onSelect.bind(this));
        applyDefaultButtonAnimation(button);

        if (Game.store.getState().playerState.settings.cinematicMode) {
            this.getComponent<Renderable>(Renderable).visible = false;
        }
    }

    private onSelect(): void {
        const state = Game.store.getState();
        const gameScene = state.activeScene.result;

        if (
            gameScene === GameScene.WORLD ||
            (state.levelState?.cardsState && !isLevelCompletedSuccessfully(state.levelState)) // prevent opening when level has been completed
        ) {
            UIActions.showPopup(PopupID.SETTINGS_MENU, {
                gameScene,
            });
        }
    }

    public get button(): GameObject {
        return this.findChildByName(SettingsButton.BTN_NAME);
    }
}
